const AppVersion = () => {
    return <div id="app_version">Version 1.0.62</div>
}

export default AppVersion;